import React from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ALoader from 'views/pages/manage/common/a-loader';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { Tooltip } from "@mui/material";
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";

const ListComponent = ({
    currentPage = 0,
    currPageSize,
    rowCount,
    nextButtonHandler,
    rows,
    isLoading
}) => {
    const history = useHistory();

    const columns = [
        new AGridColDef("id", " Sr no.", false)
            .setMinWidth(130)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <div><Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip></div> : <div>-</div>
            )),
        new AGridColDef("state", "State", false)
            .setMinWidth(130)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <div><Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip></div> : <div>-</div>
            )),
        new AGridColDef("businessUnit", "BU", false)
            .setMinWidth(130)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <div><Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip></div> : <div>-</div>
            )),
        new AGridColDef("businessUnitType", "BU Type", false)
            .setMinWidth(130)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <div><Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip></div> : <div>-</div>
            )),
        new AGridColDef("effectiveDate", "Effective date", false)
            .setMinWidth(130)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <div><Tooltip title={params?.value}>
                    <div className={`ellipsis-text-container`}>{params?.value}</div>
                </Tooltip></div> : <div>-</div>
            )),
        new AGridColDef("createdOn", "Created on", false)
            .setMinWidth(130)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={`${moment(params?.value).format('DD-MM-YYYY')} at ${moment(params?.value).format('hh:mm A')}, by ${params?.row?.createdBy}`}>
                    <div className={`ellipsis-text-container`} >{`${moment(params?.value).format('DD-MM-YYYY')} at ${moment(params?.value).format('hh:mm A')}, by ${params?.row?.createdBy}`}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("updatedOn", "Updated on", false)
            .setMinWidth(130)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={`${moment(params?.value).format('DD-MM-YYYY')} at ${moment(params?.value).format('hh:mm A')}, by ${params?.row?.updatedBy}`}>
                    <div className={`ellipsis-text-container`} >{`${moment(params?.value).format('DD-MM-YYYY')} at ${moment(params?.value).format('hh:mm A')}, by ${params?.row?.updatedBy}`}</div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("actions", "Actions", false)
            .setMinWidth(130)
            .setFlex(1)
            .pinColumnLast(true)
            .renderCellComponent((params) => (
                <AButton
                    variant="primary_filled"
                    size="xs"
                    onClick={() => {
                        history.push(`/admin/invigilatorPayrateSlab/${params.row.id}`);
                    }}
                >
                    View
                </AButton>
            )),

    ];

    return (
        <>
            {isLoading && <ALoader position="fixed" />}
            {rows?.length > 0 && <div className="mt-3">
                <ADataGrid
                    removeWrapperContainer
                    // rowModesModel={rowModesModel}
                    rows={rows || []}
                    columns={columns}
                    rowId={(row) => row?.id}
                    rowHeight={50}
                    rowCount={rowCount}
                    loading={false}
                    currentPage={currentPage}
                    nextButtonHandler={nextButtonHandler}
                    sx={{
                        ...gridStyles,
                    }}
                    autoHeight
                    paginationModel={{ page: currentPage, pageSize: currPageSize }}
                />
            </div>
            }
        </>
    )
}

export default ListComponent;